import { userAdapter } from "../adapters/user-adapter";
import { userResource } from "../resources/user-resource";
import {
  ClientPutUser,
  ClientUser,
  ClientUserPhone,
  ClientUserPhoneCheck,
} from "../types/user";

export const UserRepository = {
  async fetchUser(): Promise<ClientUser> {
    const apiUser = await userResource.getUserInfo();
    return userAdapter.toClientUser(apiUser);
  },

  async patchUser(user: ClientPutUser): Promise<ClientUser> {
    const apiUser = await userResource.patchUser(user);
    return userAdapter.toClientUser(apiUser);
  },

  async postPhone(phone: ClientUserPhone): Promise<void> {
    await userResource.postPhone(phone);
  },
  async postPhoneCheck(phone: ClientUserPhoneCheck): Promise<void> {
    await userResource.postPhoneCheck(phone);
  },

  async deleteUser() {
    await userResource.deleteUser();
  },
};
